<template>
  <el-date-picker
    v-model="dateList"
    :clearable="false"
    type="daterange"
    :unlink-panels="true"
    style="width: 100%"
    range-separator="-"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    value-format="YYYY-MM-DD"
    :disabled-date="disabledDate"
    @change="handleDateChange"
    @visible-change="handleVisibleChange"
    :disabled="props.disabled"
    ref="datePicker"
  />
</template>
<script setup>
const dateList = defineModel();
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  date_disabled: {
    type: Boolean,
    default: true
  }
});
const datePicker = ref(null);
const popperEl = ref(null);
const emit = defineEmits(["search"]);
const handleVisibleChange = visible => {
  if (visible) {
    addConfirmButton();
  } else {
    removeConfirmButton();
  }
};
const handleDateChange = () => {
  nextTick(() => {
    datePicker.value.handleOpen();
  });
};
const addConfirmButton = () => {
  popperEl.value = document.querySelector(".el-picker__popper");
  let btn = document.querySelector('[name="dateConfirmButton"]');
  if (popperEl.value && !popperEl.value.contains(btn)) {
    const confirmButton = document.createElement("button");
    confirmButton.innerText = "确认";
    confirmButton.classList.add(
      "el-button",
      "el-button--primary",
      "el-button--small"
    );
    confirmButton.style.marginTop = "10px";
    confirmButton.style.marginBottom = "10px";
    confirmButton.style.marginLeft = "10px";
    confirmButton.name = "dateConfirmButton";
    confirmButton.addEventListener("click", () => {
      datePicker.value.handleClose();
      emit("search");
    });

    const wrapperDiv = document.createElement("div");
    wrapperDiv.style.width = "98%";
    wrapperDiv.style.display = "flex";
    wrapperDiv.style.justifyContent = "flex-end";

    wrapperDiv.appendChild(confirmButton);
    popperEl.value.appendChild(wrapperDiv);
  }
};

const removeConfirmButton = () => {
  const confirmButton = document.querySelectorAll('[name="dateConfirmButton"]');
  confirmButton.forEach(button => {
    button.remove();
  });
};
function disabledDate(time) {
  if (props.date_disabled) {
    console.log(time.getTime());
    return time.getTime() > new Date().getTime();
  } else {
    return true;
  }
}
</script>
<style scoped></style>
